// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/switch-to-standard-bank/switch-to-standard-bank.component.scss
// module id = 525
// module chunks = 0